/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FindExistingBillingAccountQuery = {
    properties: {
        accountNumber: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        fullName: {
            type: 'string',
            isNullable: true,
        },
        operatorId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        hasUser: {
            type: 'boolean',
        },
    },
};